import { environment } from '@/shared/consts/environment'
import { getCookie } from '@/shared/utils'
import axios from 'axios'

export enum ClientMethodsTypes {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
  PATCH = 'PATCH',
}

export interface IClientProps {
  method?: ClientMethodsTypes
  token?: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  body?: { [key: string]: any }
  baseUrl?: string
  headers?: { [key: string]: string }
}

export const client = async <T>(
  endpoint: string,
  options?: IClientProps
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<T> => {
  const {
    method = ClientMethodsTypes.GET,
    baseUrl = environment.apiUrl,
    body,
    token,
    headers = {},
  } = options || {}

  let t = token
  let ip = null

  // Get token
  if (!t) {
    try {
      t = getCookie('token')
    } catch (e) {
      t = null
    }
  }

  // Get IP
  try {
    ip = sessionStorage.getItem('X-Client-IP')
  } catch (e) {
    ip = null
  }

  const h = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${t}`,
    'X-Client-IP': ip || '',
    ...headers,
  }

  const config = {
    method,
    url: `${baseUrl}${endpoint}`,
    headers: h,
    data: body,
  }

  try {
    const response = await axios(config)

    return response?.data
  } catch (e) {
    console.log('Error in client.ts: ', e)
    throw new Error(e)
  }
}
